import { EntityEdge, moveToFulfilled, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { GroupAddUserFulfilledAction } from '../../domains/groupAddRemoveUser/actions.types';
import {
  M365CopilotSuggestedMembersLoadFulfilledAction,
  M365CopilotSuggestedMembersLoadMoreFulfilledAction,
} from '../../domains/m365CopilotGroupSuggestedMembers/actions.types';
import { User } from '../users/types';

import { M365CopilotGroupSuggestedMembers } from './types';

export type M365CopilotGroupSuggestedMembersAction =
  | M365CopilotSuggestedMembersLoadFulfilledAction
  | M365CopilotSuggestedMembersLoadMoreFulfilledAction
  | GroupAddUserFulfilledAction;

export const initialState: M365CopilotGroupSuggestedMembers = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const filterMembersNotIncludingUser = (edges: EntityEdge<User>[], userId: User['id']) =>
  edges.filter((edge) => edge.nodeId !== userId);

type AppendMoreMembersAction = (
  state: M365CopilotGroupSuggestedMembers,
  payload: M365CopilotSuggestedMembersLoadMoreFulfilledAction['payload']
) => M365CopilotGroupSuggestedMembers;
const appendMoreMembers: AppendMoreMembersAction = (state, { id: groupId, entities }) => {
  const newEntities = entities.m365CopilotGroupSuggestedMembers?.[groupId];

  if (!newEntities) {
    return state;
  }

  const existingMembers = state.fulfilled.byId[groupId].members;

  const updatedM365CopilotGroupSuggestedMembers = {
    members: existingMembers.concat(newEntities.members),
    hasMoreMembers: newEntities.hasMoreMembers,
  };

  return update(state, groupId, updatedM365CopilotGroupSuggestedMembers);
};

const removeMemberFromSuggestedMembers = (
  state: M365CopilotGroupSuggestedMembers,
  { groupId, userId }: GroupAddUserFulfilledAction['payload']
) => {
  const m365CopilotGroupSuggestedMember = state.fulfilled.byId[groupId];

  if (!m365CopilotGroupSuggestedMember) {
    return state;
  }

  const { members } = m365CopilotGroupSuggestedMember;

  const updatedMembers = {
    ...m365CopilotGroupSuggestedMember,
    members: filterMembersNotIncludingUser(members, userId),
  };

  return update(state, groupId, updatedMembers);
};

const reducer: Reducer<M365CopilotGroupSuggestedMembers, M365CopilotGroupSuggestedMembersAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'M365_COPILOT_SUGGESTED_MEMBERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.m365CopilotGroupSuggestedMembers);
    case 'M365_COPILOT_SUGGESTED_MEMBERS.LOAD_MORE_FULFILLED':
      return appendMoreMembers(state, action.payload);
    case 'GROUP.ADD_USER_FULFILLED':
      return removeMemberFromSuggestedMembers(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
